import {
  useEffect, useRef, useState
} from 'react';
import useSWR from 'swr';

import { swrTaskRunListFetcher } from '../api_functions/listTaskRuns'

const useTaskRunList = ({ ids, taskRunFilter }) => {
  const errorTimeoutRef = useRef(null);
  const [errorMessage, setError] = useState(null);

  const timeRange = taskRunFilter?.timeRange;
  const status = taskRunFilter?.taskRunStatus;
  const {
    data, error, isLoading,
  } = useSWR([ids, timeRange, status, 'task-run-list'], swrTaskRunListFetcher, { refreshInterval: 5000 })

  useEffect(() => {
    if (error) {
      errorTimeoutRef.current = setTimeout(() => {
        setError(error?.message);
      }, 1500);
    } else {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }

    return () => {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }
  }, [error]);

  return {
    taskRunListData: data,
    error: errorMessage,
    loading: isLoading,
  };
};

export default useTaskRunList;
